import { normalizeSandUnit } from './brickSandUnits';

/** Sand used = (good bricks ÷ 1000) × recipe rate. */
export function calcSandQuantityForBricks(netPieces, sandPer1000Bricks) {
  const net = Number(netPieces) || 0;
  const rate = Number(sandPer1000Bricks) || 0;
  if (net <= 0 || rate <= 0) return '';
  const qty = (net / 1000) * rate;
  return String(parseFloat(qty.toFixed(3)));
}

export function calcSandPerCementBagFromPer1000(sandPer1000Bricks, bricksPerCementBag) {
  const rate = Number(sandPer1000Bricks) || 0;
  const perBag = Number(bricksPerCementBag) || 0;
  if (rate <= 0 || perBag <= 0) return '';
  return String(parseFloat(((rate / 1000) * perBag).toFixed(3)));
}

export function calcSandPer1000FromPerBag(sandPerCementBag, bricksPerCementBag) {
  const sand = Number(sandPerCementBag) || 0;
  const perBag = Number(bricksPerCementBag) || 0;
  if (sand <= 0 || perBag <= 0) return '';
  return String(parseFloat(((sand / perBag) * 1000).toFixed(3)));
}

export function effectiveSandPerCementBag(type) {
  if (!type) return 0;
  const direct = Number(type.sandPerCementBag) || 0;
  if (direct > 0) return direct;
  const derived = calcSandPerCementBagFromPer1000(type.sandPer1000Bricks, type.bricksPerCementBag);
  return Number(derived) || 0;
}

/** Expected good bricks from cement bags × recipe yield. */
export function calcExpectedBricksFromCementBags(cementBags, bricksPerCementBag) {
  const bags = Number(cementBags) || 0;
  const perBag = Number(bricksPerCementBag) || 0;
  if (bags <= 0 || perBag <= 0) return 0;
  return Math.round(bags * perBag);
}

/** Expected sand (tonnes) from cement bags × recipe rate per bag. */
export function calcSandTonnesFromCementBags(cementBags, sandPerCementBag) {
  const bags = Number(cementBags) || 0;
  const perBag = Number(sandPerCementBag) || 0;
  if (bags <= 0 || perBag <= 0) return 0;
  return parseFloat((bags * perBag).toFixed(3));
}

/** Optional hint for cement — user still enters bags manually. */
export function suggestCementBags(netPieces, bricksPerCementBag) {
  const net = Number(netPieces) || 0;
  const perBag = Number(bricksPerCementBag) || 0;
  if (net <= 0 || perBag <= 0) return null;
  return parseFloat((net / perBag).toFixed(2));
}

export function formatCementBagHint(bags) {
  if (bags == null || !Number.isFinite(bags)) return null;
  return bags % 1 === 0 ? String(bags) : bags.toFixed(1);
}

export function sandRecipeLabel(sandPer1000) {
  const rate = Number(sandPer1000) || 0;
  if (rate <= 0) return null;
  return `${rate} tone kwa kila 1,000 matofali`;
}

export function sandRecipePerBagLabel(sandPerCementBag) {
  const rate = Number(sandPerCementBag) || 0;
  if (rate <= 0) return null;
  return `${rate} tone kwa mifuko 1 ya cement`;
}

export function formatBrickVariance(variance) {
  const v = Number(variance) || 0;
  if (v === 0) return '0';
  return v > 0 ? `+${v}` : String(v);
}
